import { Controller } from 'stimulus'
import throttle from 'lodash/throttle'

export default class extends Controller {
  connect() {
    this.prevElement =
      document.body.querySelector(this.element.dataset.prevElementTarget) || this.element.previousElementSibling

    this.prevElementPadBottom = this.prevElement
      ? parseFloat(window.getComputedStyle(this.prevElement).getPropertyValue('padding-bottom'))
      : 0

    this.setMarginTop = throttle(this.setMarginTop, 100)
    this.setMarginTop()
  }

  setMarginTop() {
    const rect = this.element.getBoundingClientRect()
    this.element.style.marginTop = `${-rect.height / 2}px`

    if (this.prevElement) {
      this.prevElement.style.marginBottom = `${this.prevElementPadBottom + rect.height / 2}px`
    }
  }
}
